export * from './stat/stat.module';
export * from './page-header/page-header.module';
export * from './shared.module';



// WEBPACK FOOTER //
// ./src/app/shared/modules/index.ts